<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/avatars/6.jpg"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="changePassword" v-if="getCorsID()>0"><i class="fa fa-lock" /> Cambia Password</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-keyk" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  mixins: [window.myMixin],
  methods:{
    logout: function(){
      console.log("logout!")
      sessionStorage.setItem(window.keyname, "null");
      this.$router.push("/pages/login")
    },
    changePassword: function(){
      console.log("chgPass!")
      this.$router.push("/pages/chgpass")
    }
  }
}
</script>
